import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Chip from 'material-ui/Chip';
import TextField from 'material-ui/TextField';
import { List, ListItem, makeSelectable } from 'material-ui/List';

import Dropdown from './Dropdown';
import { localize } from '../i18n';

const SelectableList = makeSelectable(List);

class AutocompleteLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changedLocations: this.props.selectedLocations,
      revertLocations: this.props.selectedLocations,
      filteredLocations: [],
      locationFilter: '',
      dropdownViewRequest: 'close',
      locationsLoaded: this.props.locationsLoaded,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locationsLoaded !== this.state.locationsLoaded) {
      this.setState({
        changedLocations: nextProps.selectedLocations,
        revertLocations: nextProps.selectedLocations,
      });
    }
  }

  filterLocations(evt, type, value) {
    let filteredLocations = this.props.locations;
    if (type === 'search' && value.length > 0) {
      filteredLocations = _.filter(this.props.locations, loc => loc.location_name.indexOf(value) !== -1 && _.find(this.state.changedLocations, { location_name: loc.location_name }) === undefined);
    }
    this.setState(Object.assign({}, this.state, {
      filteredLocations,
      locationFilter: value,
      dropdownViewRequest: 'open',
    }));
  }

  handleFocus() {
    if (this.state.locationFilter !== '') {
      this.setState({
        dropdownViewRequest: 'open',
      });
    }
  }

  handleItemSelect(evt, type, loc) {
    const currentSelectedLocations = this.state.changedLocations;
    let currentFilteredLocations = this.state.filteredLocations;
    let locationFilter = this.state.locationFilter;
    let dropdownViewRequest = this.state.dropdownViewRequest;
    let location = loc;
    if (loc === 'add-location') {
      location = {
        location_name: this.state.locationFilter,
        location_type: 'unverified',
      };
      locationFilter = '';
      dropdownViewRequest = 'close';
    }
    const currentSelectedIdx = _.findIndex(currentSelectedLocations, { location_name: location.location_name });
    if (type === 'delete' && currentSelectedIdx !== -1) {
      currentSelectedLocations.splice(currentSelectedIdx, 1);
    } else if (type === 'add' && currentSelectedIdx === -1) {
      currentSelectedLocations.push({
        location_name: location.location_name,
        location_type: location.location_type,
      });
    }
    currentFilteredLocations = _.filter(this.state.filteredLocations, (filtered) => {
      if (locationFilter !== '') {
        return filtered.location_name.indexOf(locationFilter) !== -1 && _.find(currentSelectedLocations, { location_name: filtered.location_name }) === undefined;
      }
      return _.find(currentSelectedLocations, { location_name: filtered.location_name }) === undefined;
    });
    this.setState(Object.assign({}, this.state, {
      changedLocations: currentSelectedLocations,
      filteredLocations: currentFilteredLocations,
      locationFilter,
      dropdownViewRequest,
    }), () => {
      this.props.onChange(this.state.changedLocations);
    });
  }

  processLocationName(item) {
    if (item.location_type === 'guest_room') {
      return this.props.t('Room {itemLocationName}', { itemLocationName: item.location_name });
    }
    return item.location_name.toUpperCase();
  }

  renderLocationChips(location, idx) {
    const chipLocationProps = {
      key: `location-${idx}`,
      style: { margin: '0 10px 10px 0' },
    };

    if (this.props.edit === true) {
      chipLocationProps.onRequestDelete = evt => this.handleItemSelect(evt, 'delete', location);
    }

    return React.createElement(Chip, chipLocationProps, this.processLocationName(location));
  }

  render() {
    const {
      filteredLocations,
      changedLocations,
      dropdownViewRequest,
      locationFilter,
    } = this.state;
    const {
      locations,
      locationsLoaded,
      edit,
    } = this.props;
    let locationList = null;
    let renderedLocations = (
      <span className="uk-text-italic">
        {this.props.t('Loading... ({locationsLength})', { locationsLength: locations.length })}
      </span>
    );
    let addLocations = null;

    if (locationsLoaded === true) {
      if (changedLocations.length > 0) {
        renderedLocations = (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {changedLocations.map((location, idx) => this.renderLocationChips(location, idx))}
          </div>
        );
      } else {
        renderedLocations = null;
      }
      if (edit === true) {
        locationList = [];
        if (filteredLocations.length > 0) {
          locationList = filteredLocations.slice(0, 14).map(loc => (
            <ListItem
              key={loc.id}
              primaryText={(loc.location_type === 'guest_room') ? this.props.t('Room {locationName}', { locationName: loc.location_name }) : loc.location_name.toUpperCase()}
              value={loc}
              innerDivStyle={{ padding: 5 }}
            />
          ));
        }
        locationList.push((
          <ListItem
            key="add-location"
            primaryText={this.props.t('Add custom location')}
            value="add-location"
            innerDivStyle={{ padding: 5 }}
          />
        ));

        addLocations = (
          <div>
            <Dropdown
              request={dropdownViewRequest}
              size="xlarge"
              type="input"
              trigger={(
                <TextField
                  value={locationFilter}
                  fullWidth
                  hintText={this.props.t('Add location')}
                  onChange={evt => this.filterLocations(evt, 'search', evt.target.value)}
                  onFocus={evt => this.handleFocus(evt)}
                />
              )}
              onChange={(opened) => {
                this.setState({
                  dropdownViewRequest: (opened === true) ? 'open' : 'close',
                });
              }}
            >
              <SelectableList
                onChange={(evt, location) => {
                  this.handleItemSelect(evt, 'add', location);
                }}
              >
                {locationList}
              </SelectableList>
            </Dropdown>
          </div>
        );
      }
    }

    return (
      <div className="AutocompleteLocations">
        {renderedLocations}
        {addLocations}
      </div>
    );
  }
}

AutocompleteLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    location_type: PropTypes.string,
    location_name: PropTypes.string,
    location_sort: PropTypes.number,
  })),
  selectedLocations: PropTypes.arrayOf(PropTypes.shape({
    location_type: PropTypes.string,
    location_name: PropTypes.string,
  })),
  onChange: PropTypes.func,
  edit: PropTypes.bool,
  locationsLoaded: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

AutocompleteLocations.defaultProps = {
  onChange: () => {},
  edit: false,
};

export default localize(AutocompleteLocations);



// WEBPACK FOOTER //
// ./src/components/AutocompleteLocations.js